<template>
    <div class="AdminBuilder">
        <FadeTransition mode="out-in">
            <div
                :key="entityKey"
                class="AdminBuilderHeader flex row-stretch-center"
                :class="{ 'Separate': store.buttons || breadcrumbs}"
            >
                <Breadcrumbs :breadcrumbs="breadcrumbs" />
                <div class="Actions flex row-top-stretch">
                    <WButton
                        v-for="({ text, disabled, onClick, ...otherProps }, index) in buttons"
                        :key="index"
                        :disabled="disabled"
                        v-bind="otherProps"
                        class="ml-1"
                        @click="onClick"
                    >
                        {{ text }}
                    </WButton>
                    <Reload class="ml-1" />
                </div>
            </div>
        </FadeTransition>
        <Transition
            name="main-router"
            mode="out-in"
        >
            <RouterView
                :key="entityKey"
                :entityKey="entityKey"
            />
        </Transition>
    </div>
</template>

<script>
import { Breadcrumbs, Reload } from '@/components'

export default {
    name: 'AdminBuilderScreen',
    components: {
        Breadcrumbs,
        Reload,
    },
    provide () {
        return {
            Entity: this,
        }
    },
    data () {
        return {
            store: {},
        }
    },
    computed: {
        entityKey () {
            return (this.$route.meta || {}).key
        },
        breadcrumbs () {
            const { breadcrumbs } = this.store

            return [
                {
                    key: 'AdminBuilder',
                    label: this.$t('entities.title'),
                    to: { name: 'AdminBuilder' },
                },
                ...(breadcrumbs || ((this.$route.meta || {}).breadcrumb ? [{
                    key: this.$route.name,
                    label: this.$route.meta.breadcrumb,
                    to: { name: this.$route.name },
                }] : [])),
            ]
        },
        buttons () {
            return [...(this.store.buttons || [])]
        },
    },
}
</script>
<style lang="scss" scoped>
.AdminBuilder {
    display: flex;
    flex-direction: column;
    flex: 1;
    .AdminBuilderHeader{
        min-height: 34px;
        &.Separate {
            margin-bottom: 20px;
        }
    }
}
</style>
